export default "__VITE_ASSET__DwIuW2o$__"